import React, { useState, useRef } from "react";
import { Box, Typography, Button, Tabs, Tab, Tooltip } from "@mui/material";
import SingleRunSecurityMetricsComponent from "./SingleRunSecurityMetricsComponent.js";
import SingleRunInsightsRecommendationsComponent from "./SingleRunInsightsRecommendationsComponent.js";
import { ReactComponent as DownloadFullReportIcon } from "../../../../images/DownloadFullReportIcon.svg";
import SecurityMetrics from "./SecurityMetrics.js";
import ComparisonMetrics from "./ComparisonMetrics.js";
import InsightsAndRecommendations from "./InsightsAndRecommendations.js";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  downloadNodeAsHtml,
  makeTimestampedName,
} from "../../../common-components/DownloadHTML.js";

export default function DastInsightsComponent() {
  const location = useLocation();
  // Add a ref to capture the entire dashboard content
  const dashboardRef = useRef(null);

  const [tabIndex, setTabIndex] = useState(0);
  const [runAnalysis, setRunAnalysis] = useState("");
  const [securityMetrics, setSecurityMetrics] = useState({});
  const [insightsAndRecs, setInsightsAndRecs] = useState([]);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    // Effect logic here
    setRunAnalysis(location.state?.runAnalysis);
    setSecurityMetrics(location.state?.securityMetrics || {});
    setInsightsAndRecs(location.state?.insightsAndRecs || []);
  }, [location.state]);

  function handleDownloadHTML() {
    const filename = makeTimestampedName("SAST-Dashboard", "html");
    downloadNodeAsHtml(dashboardRef, {
      filename,
      selfContained: true,
      includeExternalCssLinks: false,
      captureCharts: true, // This is now the default
    });
  }

  // Enhanced download function - HTML format only
  //   const handleDownloadHTML = async () => {
  //     if (!dashboardRef.current) return;

  //     const originalButton = document.querySelector("[data-download-button]");

  //     // Store original state
  //     const originalText = originalButton?.textContent || "Download";
  //     const originalDisabled = originalButton?.disabled || false;
  //     const originalBackgroundColor =
  //       originalButton?.style.backgroundColor || "#49A3FF";

  //     try {
  //       // Disable button and show loading state
  //       if (originalButton) {
  //         originalButton.textContent = "Downloading...";
  //         originalButton.disabled = true;
  //         originalButton.style.backgroundColor = "#A5A5A5"; // Gray out the button
  //         originalButton.style.cursor = "not-allowed";
  //       }

  //       // Generate high-quality canvas
  //       const canvas = await html2canvas(dashboardRef.current, {
  //         useCORS: true,
  //         scale: 2, // High resolution
  //         backgroundColor: "#F5F5F5",
  //         allowTaint: true,
  //         scrollX: 0,
  //         scrollY: 0,
  //         width: dashboardRef.current.scrollWidth,
  //         height: dashboardRef.current.scrollHeight,
  //         onclone: (clonedDoc) => {
  //           // Ensure all styles are captured in the cloned document
  //           const clonedElement = clonedDoc.querySelector("[data-dashboard-ref]");
  //           if (clonedElement) {
  //             clonedElement.style.transform = "none";
  //           }
  //         },
  //       });

  //       // Get filename based on current tab
  //       const getTabName = () => {
  //         if (runAnalysis === "Single Run Analysis") {
  //           return tabIndex === 0 ? "SecurityMetrics" : "InsightsRecommendations";
  //         } else if (runAnalysis === "Comparison Analysis") {
  //           if (tabIndex === 0) return "SecurityMetrics";
  //           if (tabIndex === 1) return "ComparisonMetrics";
  //           return "InsightsRecommendations";
  //         }
  //         return "Dashboard";
  //       };

  //       const timestamp = new Date().toISOString().split("T")[0];
  //       const filename = `DAST_${getTabName()}_${timestamp}`;

  //       // Convert canvas to image data
  //       const imgData = canvas.toDataURL("image/png", 1.0);

  //       // Create HTML with embedded image
  //       const htmlContent = `
  // <!DOCTYPE html>
  // <html lang="en">
  // <head>
  //     <meta charset="UTF-8">
  //     <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //     <title>DAST Security Analysis Dashboard - ${getTabName()}</title>
  //     <style>
  //         body {
  //             margin: 0;
  //             padding: 20px;
  //             font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  //             background-color: #f5f5f5;
  //         }
  //         .dashboard-image {
  //             width: 100%;
  //             height: auto;
  //             border-radius: 8px;
  //             box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  //         }
  //         .header {
  //             text-align: center;
  //             margin-bottom: 20px;
  //         }
  //         .timestamp {
  //             color: #666;
  //             font-size: 14px;
  //             margin-top: 10px;
  //         }
  //     </style>
  // </head>
  // <body>
  // <img src="${imgData}" alt="DAST Dashboard ${getTabName()}" class="dashboard-image">
  // </body>
  // </html>`;

  //       // Download HTML version only
  //       const htmlBlob = new Blob([htmlContent], { type: "text/html" });
  //       const htmlUrl = URL.createObjectURL(htmlBlob);
  //       const htmlLink = document.createElement("a");
  //       htmlLink.href = htmlUrl;
  //       htmlLink.download = `${filename}.html`;
  //       htmlLink.click();
  //       URL.revokeObjectURL(htmlUrl);
  //     } catch (error) {
  //       console.error("Error generating download:", error);
  //       alert("Error generating download. Please try again.");
  //     } finally {
  //       // 🆕 Always restore button to original state (success or failure)
  //       if (originalButton) {
  //         originalButton.textContent = originalText;
  //         originalButton.disabled = originalDisabled;
  //         originalButton.style.backgroundColor = originalBackgroundColor;
  //         originalButton.style.cursor = "pointer";
  //       }
  //     }
  //   };

  // Optional: PDF download function
  const handleDownloadPDF = async () => {
    if (!dashboardRef.current) return;

    // Find the PDF button - adjust selector as needed for your button
    const pdfButton = Array.from(document.querySelectorAll("button")).find(
      (btn) =>
        btn.textContent.includes("PDF") ||
        btn.textContent.includes("Download PDF")
    );

    // Store original state
    const originalText = pdfButton?.textContent || "Download PDF";
    const originalDisabled = pdfButton?.disabled || false;
    const originalBackgroundColor =
      pdfButton?.style.backgroundColor || "#49A3FF";

    try {
      // Disable button and show loading state
      if (pdfButton) {
        pdfButton.textContent = "Downloading...";
        pdfButton.disabled = true;
        pdfButton.style.backgroundColor = "#A5A5A5"; // Gray out the button
        pdfButton.style.cursor = "not-allowed";
      }

      const canvas = await html2canvas(dashboardRef.current, {
        useCORS: true,
        scale: 2,
        backgroundColor: "#F5F5F5",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("l", "mm", "a4"); // landscape orientation

      const imgWidth = 297; // A4 width in mm (landscape)
      const pageHeight = 210; // A4 height in mm (landscape)
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const getTabName = () => {
        if (runAnalysis === "Single Run Analysis") {
          return tabIndex === 0 ? "SecurityMetrics" : "InsightsRecommendations";
        } else if (runAnalysis === "Comparison Analysis") {
          if (tabIndex === 0) return "SecurityMetrics";
          if (tabIndex === 1) return "ComparisonMetrics";
          return "InsightsRecommendations";
        }
        return "Dashboard";
      };

      pdf.save(
        `DAST_${getTabName()}_${new Date().toISOString().split("T")[0]}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
    } finally {
      // 🆕 Always restore button to original state (success or failure)
      if (pdfButton) {
        pdfButton.textContent = originalText;
        pdfButton.disabled = originalDisabled;
        pdfButton.style.backgroundColor = originalBackgroundColor;
        pdfButton.style.cursor = "pointer";
      }
    }
  };

  const tabSx = {
    textTransform: "none",
    fontSize: "14px",
    color: "#000000",
    fontWeight: 600,
    fontFamily: "Manrope",
  };

  return (
    <Box
      ref={dashboardRef}
      data-dashboard-ref
      sx={{ minHeight: "100vh", bgcolor: "#F5F5F5" }}
    >
      {/* Security Analysis Header */}
      <Box
        sx={{
          height: { xs: "auto", md: "15vh" },
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          borderRadius: "12px",
          padding: 4,
          mt: 1,
          mb: 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            gap: 2,
          }}
        >
          {/* Left: Title & Subtitle */}
          <Box>
            <Typography
              sx={{
                fontSize: "27px",
                fontFamily: "Manrope",
                fontWeight: 700,
                color: "#000000",
              }}
            >
              DAST Security Analysis Dashboard
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                color: "#000000",
                fontFamily: "Manrope",
                fontWeight: 400,
                mt: 2,
              }}
            >
              {runAnalysis === "Single Run Analysis"
                ? " Comprehensive security analysis • 1 report processed"
                : "Comparison analysis between two scan runs • 2 reports processed"}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
          <Tooltip
            title="Download current tab as HTML"
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 300,
                  fontSize: "14px",
                  lineHeight: 1.4,
                },
              },
            }}
          >
            <Button
              sx={{
                width: "160px",
                height: "40px",
                backgroundColor: "#49A3FF",
                fontSize: "14px",
                textTransform: "none",
                borderRadius: "8px",
                color: "#FFFFFF",
              }}
              data-download-button
              onClick={handleDownloadHTML}
            >
              Download HTML
            </Button>
          </Tooltip>
          <Tooltip
            title="Download current tab as PDF"
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 300,
                  fontSize: "14px",
                  lineHeight: 1.4,
                },
              },
            }}
          >
            <Button
              sx={{
                width: "121px",
                height: "40px",
                backgroundColor: "#49A3FF",
                fontSize: "14px",
                textTransform: "none",
                borderRadius: "8px",
                color: "#FFFFFF",
              }}
              onClick={handleDownloadPDF}
            >
              Download PDF
            </Button>
          </Tooltip>
          {/* <Button
            sx={{
              width: "121px",
              height: "40px",
              fontSize: "14px",
              textTransform: "none",
              borderRadius: "8px",
              color: "#49A3FF",
              border: "1px solid #49A3FF",
              backgroundColor: "transparent",
            }}
            startIcon={<DownloadFullReportIcon width="20" height="20" />}
            onClick={() => setOpenDownload(true)}
          >
            Full Report
          </Button> */}
        </Box>
      </Box>

      {/* Tabs and Content Placeholder */}
      <Box sx={{ mt: 4, mb: 4 }}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="fullWidth"
          sx={{
            backgroundColor: "#DFDFDF",
            border: "2px",
            borderRadius: "4px",
            "& .MuiTabs-indicator": {
              backgroundColor: "#49A3FF",
            },
            height: "50px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/*Single Run Security Metrics Tab */}
          {runAnalysis === "Single Run Analysis" && (
            <Tab label="Security Metrics" sx={tabSx} />
          )}

          {/*Single Run Insights (Always visible) */}
          {runAnalysis === "Single Run Analysis" && (
            <Tab label="Insights & Recommendations" sx={tabSx} />
          )}

          {/*Comparisoin Analysis Security Metrics Tab*/}
          {runAnalysis === "Comparison Analysis" && (
            <Tab label="Security Metrics" sx={tabSx} />
          )}

          {runAnalysis === "Comparison Analysis" && (
            <Tab label="Comparison Metrics" sx={tabSx} />
          )}

          {runAnalysis === "Comparison Analysis" && (
            <Tab label="Insights & Recommendations" sx={tabSx} />
          )}
        </Tabs>

        {/* Tab Panels */}
        {runAnalysis === "Single Run Analysis" && tabIndex === 0 && (
          <SingleRunSecurityMetricsComponent
            singleRunSecurityMetrics={securityMetrics}
          />
        )}

        {runAnalysis === "Single Run Analysis" && tabIndex === 1 && (
          <SingleRunInsightsRecommendationsComponent
            singleRunSecurityMetrics={securityMetrics}
            singleRunInsightsAndRecs={insightsAndRecs}
          />
        )}

        {runAnalysis === "Comparison Analysis" && tabIndex === 0 && (
          <SecurityMetrics securityMetrics={securityMetrics} />
        )}

        {runAnalysis === "Comparison Analysis" && tabIndex === 1 && (
          <ComparisonMetrics comparisonMetrics={securityMetrics} />
        )}

        {runAnalysis === "Comparison Analysis" && tabIndex === 2 && (
          <InsightsAndRecommendations
            securityMetrics={securityMetrics}
            insightsAndRecs={insightsAndRecs}
          />
        )}
      </Box>
    </Box>
  );
}
